import type { RuleObject } from 'antd/es/form';

// Canonical phone-number validation for the admin web app.
//
// Mirrors the backend validator (ClientService.IsValidPhone): accept an
// optional single leading "+" followed by 7–15 digits, ignoring spaces,
// hyphens and parentheses. This lets users type or paste naturally-formatted
// international numbers such as "+44 20 7946 0123" or "(020) 7946-0123" — which
// the mobile `type="tel"` keypad (FORT-294) actively encourages — without
// hitting a digits-only validation error.
//
// Phone numbers are stored raw: dbo.member.phone_number is a varchar and the
// member-create endpoint only trims. Search normalises to digits via a trigram
// index on regexp_replace(phone_number, '\D', ''), so we validate the shape but
// deliberately do NOT rewrite the value the user entered.
const PHONE_REGEX = /^\+?[0-9]{7,15}$/;

export function isValidPhone(phone: string): boolean {
    return PHONE_REGEX.test(phone.replace(/[\s\-()]/g, ''));
}

// Reusable Ant Design Form.Item rule for phone fields. Accepts empty input, so
// pair it with `{ required: true }` where the field is mandatory.
export function phoneNumberRule(message = 'Please enter a valid phone number'): RuleObject {
    return {
        validator: (_, value: string) =>
            !value || isValidPhone(value) ? Promise.resolve() : Promise.reject(new Error(message)),
    };
}
